import { EncounterTemplateControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useRosPeTemplateArchive = () =>
  useMutationWithLoading(
    async (params: {
      encounterTemplateId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new EncounterTemplateControllerApi(
        getConfigObject()
      ).updatePatientOrderArchiveStatus1(
        params?.encounterTemplateId,
        params?.status,
        params?.xTENANTID
      )
  );
